import { Component, OnInit, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: '../templates/login.component.html'
})

@Injectable()
export class LoginComponent implements OnInit {

  title = 'Login';

  constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService) {
  }

  ngOnInit() {

  }

  authExternalProvider(provider:string) {

    var redirectUri = location.protocol + '//' + location.host + '/authcomplete.html';

    var externalProviderUrl ="https://authorization-qa-bo.azurewebsites.net/api/" // backOfficeConfiguration.AuthorizationApiUrl
      + "Account/ExternalLogin?provider=" + provider
      + "&response_type=token"
      + "&redirect_uri=" + redirectUri;

    // window.$windowScope = $scope;

    var oauthWindow = window.open(externalProviderUrl, "Authenticate Account", "location=0,status=0,width=600,height=750");
  };

  public authCompletedCB = function (fragment) {
    var externalData = { provider: fragment.provider, externalAccessToken: fragment.external_access_token };
    this.authService.obtainAccessToken(externalData).then(function (response) {
      Promise.all([this.authService.loadModule()])
        .then(function (arrayResponse) {
          this.router.navigate(['/dashboard']);
        });
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/authentication/components/scripts/login.component.ts